import { Checkbox } from '@components-deprecated'

import { Color, Spacing } from '@billy/design-system'
import { keyframes } from '@emotion/core'
import styled from '@emotion/styled'

import { zIndex } from '../../../styles-deprecated'
import { Themable } from '../../../types/themable'

interface NavSliderProps {
  visible?: boolean
}

export const SelectionPanelWrapper = styled.div<Themable>`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
`

export const SelectionPanelCheckbox = styled(Checkbox)`
  align-items: center;
  margin-bottom: -${Spacing.S2};
`

export const SelectionPanelText = styled.span``

export const SelectionPanelButtonWrapper = styled.div`
  margin-left: 10px;
`

export const NavSlider = styled.nav<NavSliderProps>`
  width: 370px;
  position: absolute;
  transform: translateX(${({ visible }) => (visible ? '0px' : '-370px')});
  white-space: nowrap;
  overflow: hidden;
  transition: transform 0.2s ease-out;
  will-change: transform;
`

export const HelpBadge = styled.span`
  margin-right: 4px;
  position: relative;
  top: -1px;
  pointer-events: auto;
`

export const CommentButton = styled.button<Themable>`
  margin: 0 4px 0 0;
  padding: 0;
  border: 0;
  position: relative;
  z-index: ${zIndex.aboveElement};
  color: ${Color.Lavender500};
  cursor: pointer;
  pointer-events: auto;

  svg {
    fill: currentColor;
  }
`

export const MissingReceiptsModeButton = styled.div``

export const BankLogoWrapper = styled.figure`
  display: flex;
  opacity: 0.3;
  justify-content: center;
`
const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const LoadingWrapper = styled.div`
  display: inline-flex;
  opacity: 0.4;
  align-items: center;
  justify-content: center;
  animation: ${spin} 2s ease infinite;
`

export const TableHeaderWrapper = styled.div`
  display: flex;
  gap: ${Spacing.S16};
  padding: ${Spacing.S12} ${Spacing.S24};
  color: ${Color.Lavender500};

  a {
    text-decoration: none;
  }
`

interface ScrollableListProps {
  isBalanceBarOpen?: boolean
}

export const ScrollableList = styled.div<ScrollableListProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-height: ${({ isBalanceBarOpen }) => `calc(100vh - ${isBalanceBarOpen ? 394 : 320}px)`};
  padding: 0px ${Spacing.S6} ${Spacing.S32};
  overflow-x: hidden;
  overflow-y: auto;

  * [data-rbd-draggable-context-id]:not(.react-app-matched-transaction) {
    margin-bottom: 10px;
  }
`

export const MatchListGrid = styled.div`
  display: grid;
  gap: 5px;
  grid-template-columns: 280fr 230fr;
`

interface MatchListRowWrapperProps {
  isApproved: boolean
}

export const MatchListRowWrapper = styled.div<MatchListRowWrapperProps>`
  display: grid;
  column-gap: 5px;
  grid-template-columns: 280fr 230fr;
  position: relative;
  &:first-of-type {
    padding-top: 0;
  }
  &:not(:first-of-type) > .action-overlay {
    top: 11px;
  }
  p {
    opacity: ${({ isApproved }) => (isApproved ? '0.5' : '1.0')};
  }
`
